var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntegrationAndScaling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,9.25H36a.7502.7502,0,0,0-.75.75V33.25H18a.7502.7502,0,0,0-.75.75V53.25H10a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75H26a.7502.7502,0,0,0,.75-.75V62.75H46a.7502.7502,0,0,0,.75-.75V44.75H70a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,70,9.25Zm-44.75,60H10.75V54.75h6.5V62a.7502.7502,0,0,0,.75.75h7.25Zm0-8h-6.5v-6.5h6.5Zm20,0H26.75V54a.7502.7502,0,0,0-.75-.75H18.75V34.75h16.5V44a.7502.7502,0,0,0,.75.75h9.25Zm0-18h-8.5v-8.5h8.5Zm24,0H46.75V34a.7502.7502,0,0,0-.75-.75H36.75V10.75h32.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrationAndScaling);
export default __webpack_public_path__ + "static/media/icon_integration_and_scaling.12ef8bb4745e939a287f00e6f3da0849.svg";
export { ForwardRef as ReactComponent };